import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Dashboard from './pages/dashboard';
import Customers from './pages/customers';
import Projects from './pages/projects';
import Permits from './pages/permits';
import TeamMembers from './pages/team-members';
import Contractors from './pages/contractors';
import Login from './pages/login';
import SignUp from './pages/sign-up';
import LandingPage from './pages/landing';
import SignupSuccess from './pages/signup-success';
import Settings from './pages/settings';
import ReportsAnalytics from './pages/reports-analytics';
import Calendar from './pages/calendar';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/reset-password';
import PrivacyPolicy from './pages/privacy-policy';
import TermsOfUse from './pages/terms-of-use';
import DemoGuard from './components/ui/DemoGuard';
import ContactUs from './pages/contact-us';
import AcceptInvite from './pages/accept-invite';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route path="/signup-success" element={<SignupSuccess />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contractors" element={<Contractors />} />
        <Route path="/permits" element={<Permits />} />
        <Route path="/team-members" element={<TeamMembers />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/settings" element={<DemoGuard><Settings /></DemoGuard>} />
        <Route path="/reports-analytics" element={<ReportsAnalytics />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
